import { jwtDecode } from 'jwt-decode';
import { getToken } from 'services/auth';

export function refusalActorKey(context) {
  try {
    const { uid } = jwtDecode(getToken());
    if (!Number.isSafeInteger(uid) || uid <= 0) throw new Error();
    return `${uid}:${context.companyId}:${context.item.type}:${context.item.loadId}`;
  } catch {
    throw new Error('Sessão inválida. Atualize a página antes de continuar.');
  }
}
export function operationKey(context, asset, refusalId = null) {
  return `control-tower-refusal:${refusalActorKey(context)}:${asset.assetType}:${asset.id}:${refusalId || 'new'}`;
}
export function readOperation(key) {
  const raw = sessionStorage.getItem(key);
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    if (
      !/^[a-f\d]{8}(-[a-f\d]{4}){3}-[a-f\d]{12}$/i.test(value.operationId) ||
      !(typeof value.reasonCode === 'string' || value.confirmed === true) ||
      (value.note !== undefined && typeof value.note !== 'string')
    )
      throw new Error();
    return value;
  } catch {
    throw new Error('Não foi possível recuperar a operação pendente. Atualize a página.');
  }
}
export function beginOperation(key, payload) {
  const previous = readOperation(key);
  if (previous) {
    if (
      previous.reasonCode !== payload.reasonCode ||
      previous.note !== payload.note ||
      previous.confirmed !== payload.confirmed
    )
      throw new Error(
        'Confirme novamente a operação pendente antes de alterar o motivo ou a observação.',
      );
    return previous;
  }
  const command = { operationId: crypto.randomUUID(), ...payload };
  // Gravar antes do POST: não enviar quando não for possível preservar o UUID para reenvio.
  sessionStorage.setItem(key, JSON.stringify(command));
  return command;
}
export function clearOperation(key) {
  sessionStorage.removeItem(key);
}
